import React, { useEffect, useState } from 'react'
import { addToMoney } from '../../Common/apis';
import { toast } from 'react-toastify';

function DonationBalance({wallet}) {
    const [isOpen, setIsOpen] = useState(false);

    const [amount, setAmount] = useState("");
    const [loading, setLoading] = useState(false);


    const handlePayment = async (e) => {
        e.preventDefault();
        const data = {
            Amount: Number(amount)
        }
        setLoading(true);
        try {
            const response = await addToMoney(data);
            toast.success(response.message);
            setIsOpen(false)
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <div>
                <h6 className="font-[700] font-manrope text-[24px] text-[#000000] pb-[19px]">Donation Balance</h6>
                <div className='bg-[#F6F8FA] border border-[#E7E4FC] p-[30px] flex gap-[30px] mf:flex-row flex-col items-center rounded-[12px]'>
                    <div className='h-[144px] w-[144px] rounded-full bg-[#FFFFFF] flex justify-center items-center' style={{ boxShadow: "0px 0px 20px 0px #0000001A" }}>
                        <div className='h-[106px] w-[106px] bg-[#F68B29] rounded-full flex flex-col items-center justify-center'>
                            <img src="/assets/profile/coin.svg" alt="" />
                            <h6 className="font-[700] font-manrope text-center text-[31px] text-[#FFFFFF]">{wallet}</h6>
                            <p className="text-center font-[400] text-[11px] text-[#FFFFFF]">Credits</p>
                        </div>
                    </div>
                    <div className="flex gap-[16px] rounded-[12px] max-w-[328px] w-full items-center justify-start bg-[#FFFFFF] border border-[#DFE1E7] px-[8px] py-[12px]">
                        <div className='flex flex-col items-center gap-[8px] max-w-[139px] w-full'>
                            <img src="/assets/profile/item9.svg" alt="" />
                            <h6 className="font-[700] text-[16px] font-manrope text-center text-[#2B2B2B]">Withdraw</h6>
                        </div>
                        <div className='bg-[#A4ACB9] w-[1px] h-[61px]'>
                        </div>
                        <div onClick={() => setIsOpen(true)}
                            className='flex flex-col items-center gap-[8px] max-w-[139px] w-full cursor-pointer'>
                            <img src="/assets/profile/item10.svg" alt="" />
                            <h6 className="font-[700] text-[16px] font-manrope text-center text-[#2B2B2B]">Top up</h6>
                        </div>
                    </div>
                </div>
                <div className='bg-[#F6F8FA] border border-[#E7E4FC] rounded-[12px] mt-[20px] p-[20px]'>
                    <h6 className="font-[500] font-manrope text-[20px] text-[#000000] pb-[15px]">Donation Balance History</h6>
                    <div className="grid grid-cols-1 gap-[8px]">
                        <p className="py-[8px] px-[12px] text-[#515151] font-manrope font-[500] text-[13px]">April 2024</p>
                        <div>
                            <div className="flex justify-between items-center">
                                <h6 className="font-[700] font-manrope text-[16px] text-[#4D4D4D]">Top up</h6>
                                <h6 className="font-[700] font-manrope text-[16px] text-[#FF6000]">+$50</h6>
                            </div>
                            <div className="flex justify-between items-center">
                                <p className="font-[400] font-manrope text-[13px] text-[#666666]">April 20, 2024</p>
                                <h6 className="font-[400] font-manrope text-[13px] text-[#F68B29]">Success</h6>
                            </div>
                        </div>
                        <div className="max-w-[856px] h-[1px] w-full mx-auto bg-[#DFE1E7]"></div>
                        <div>
                            <div className="flex justify-between items-center">
                                <h6 className="font-[700] font-manrope text-[16px] text-[#4D4D4D]">Top up</h6>
                                <h6 className="font-[700] font-manrope text-[16px] text-[#FF6000]">+$10</h6>
                            </div>
                            <div className="flex justify-between items-center">
                                <p className="font-[400] font-manrope text-[13px] text-[#666666]">April 20, 2024</p>
                                <h6 className="font-[400] font-manrope text-[13px] text-[#F68B29]">Success</h6>
                            </div>
                        </div>
                        <div className="max-w-[856px] h-[1px] w-full mx-auto bg-[#DFE1E7]"></div>
                        <div>
                            <div className="flex justify-between items-center">
                                <h6 className="font-[700] font-manrope text-[16px] text-[#4D4D4D]">Top up</h6>
                                <h6 className="font-[700] font-manrope text-[16px] text-[#FF6000]">+$20</h6>
                            </div>
                            <div className="flex justify-between items-center">
                                <p className="font-[400] font-manrope text-[13px] text-[#666666]">April 20, 2024</p>
                                <h6 className="font-[400] font-manrope text-[13px] text-[#F68B29]">Success</h6>
                            </div>
                        </div>
                        <div className="max-w-[856px] h-[1px] w-full mx-auto bg-[#DFE1E7]"></div>
                        <div>
                            <div className="flex justify-between items-center">
                                <h6 className="font-[700] font-manrope text-[16px] text-[#4D4D4D]">Top up</h6>
                                <h6 className="font-[700] font-manrope text-[16px] text-[#FF6000]">+$20</h6>
                            </div>
                            <div className="flex justify-between items-center">
                                <p className="font-[400] font-manrope text-[13px] text-[#666666]">April 20, 2024</p>
                                <h6 className="font-[400] font-manrope text-[13px] text-[#F68B29]">Success</h6>
                            </div>
                        </div>
                        <p className="py-[8px] px-[12px] text-[#515151] font-manrope font-[500] text-[13px]">May 2024</p>
                        <div>
                            <div className="flex justify-between items-center">
                                <h6 className="font-[700] font-manrope text-[16px] text-[#4D4D4D]">Top up</h6>
                                <h6 className="font-[700] font-manrope text-[16px] text-[#FF6000]">+$20</h6>
                            </div>
                            <div className="flex justify-between items-center">
                                <p className="font-[400] font-manrope text-[13px] text-[#666666]">April 20, 2024</p>
                                <h6 className="font-[400] font-manrope text-[13px] text-[#F68B29]">Success</h6>
                            </div>
                        </div>
                        <div className="max-w-[856px] h-[1px] w-full mx-auto bg-[#DFE1E7]"></div>
                        <div>
                            <div className="flex justify-between items-center">
                                <h6 className="font-[700] font-manrope text-[16px] text-[#4D4D4D]">Top up</h6>
                                <h6 className="font-[700] font-manrope text-[16px] text-[#FF6000]">+$20</h6>
                            </div>
                            <div className="flex justify-between items-center">
                                <p className="font-[400] font-manrope text-[13px] text-[#666666]">April 20, 2024</p>
                                <h6 className="font-[400] font-manrope text-[13px] text-[#F68B29]">Success</h6>
                            </div>
                        </div>
                        <div className="max-w-[856px] h-[1px] w-full mx-auto bg-[#DFE1E7]"></div>
                    </div>
                </div>
            </div>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-md relative">
                        {/* Close Button */}
                        <button
                            onClick={() => setIsOpen(false)}
                            className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-2xl"
                        >
                            &times;
                        </button>

                        <h2 className="text-xl font-semibold mb-4">Make a Payment</h2>

                        <form onSubmit={handlePayment}>
                            <label className="block mb-2 text-gray-700 font-medium">Enter Amount:</label>
                            <input
                                type="number"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                className="w-full px-4 py-2 border rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                placeholder="1000"
                                required
                            />

                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
                            >
                                {loading ? 'Processing...' : 'Pay Now'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </>
    )
}

export default DonationBalance